import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { getCurrentSubscriptionPeriod, getNextSubsctiptionPeriod } from 'reactApp/modules/billingData/billingData.utils';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { formatLocale } from 'reactApp/utils/formatDate';
import { addPeriodToDate, getPeriodName } from 'reactApp/utils/Period';

import type { BeforeRenewModalProps } from './BeforeRenewModal';

export const renderBeforeRenewModal = ({ onClose, ...data }: BeforeRenewModalProps) =>
    openPopupHelper({ popupName: popupNames.BEFORE_RENEW_MODAL, data, onClose });

export const closeBeforeRenewModal = () => closePopupHelper(popupNames.BEFORE_RENEW_MODAL);

export const BeforeRenderModalTexts = {
    getTitle: (subscription: BillingDataSubscriptionInfo) => {
        return `Подписка активна до\u00A0${formatLocale(subscription.expires, 'dd MMMM yyyy')}.`;
    },
    getTitleQuestion: (subscription: BillingDataSubscriptionInfo) => {
        const nextPeriod = getNextSubsctiptionPeriod(subscription);
        if (nextPeriod) {
            return `Продлить ещё на\u00A0${getPeriodName(nextPeriod, true, true)}?`;
        }
        return null;
    },
    getContentRenewalText: (subscription: BillingDataSubscriptionInfo) => {
        const nextPeriod = getNextSubsctiptionPeriod(subscription);
        const parsedNextPeriod = nextPeriod && addPeriodToDate(subscription.expires, nextPeriod);
        if (parsedNextPeriod) {
            return `Если продлить, она будет активна до\u00A0${formatLocale(parsedNextPeriod, 'dd MMMM yyyy')}`;
        }
        return null;
    },
    getContentText: (subscription: BillingDataSubscriptionInfo) => {
        const currentPeriod = getCurrentSubscriptionPeriod(subscription);
        return `Вы\u00A0уже оплатили +${subscription.space.value} Mail Space на\u00A0${getPeriodName(currentPeriod, false, true)}.`;
    },
} as const;
